export { default } from './top-message-bar.component';
